interface PageHeroProps {
  image: string;
  alt: string;
  title: string;
  subtitle?: string;
}

const PageHero = ({ image, alt, title, subtitle }: PageHeroProps) => (
  <section className="relative min-h-[450px] md:min-h-[650px] flex items-center overflow-hidden pt-32 md:pt-40">
    <img
      src={image}
      alt={alt}
      className="absolute inset-0 w-full h-full object-cover"
      width={1920}
      height={1080}
    />
    <div className="absolute inset-0" style={{ background: "var(--hero-overlay)" }} />
    <div className="container relative z-10 py-16 md:py-24">
      <div className="max-w-2xl space-y-4 animate-fade-up">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] text-surface-dark-foreground">
          {title}
        </h1>
        {subtitle && (
          <p className="text-lg md:text-xl text-surface-dark-foreground/80 max-w-lg">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  </section>
);

export default PageHero;
